
import { default as Moment } from 'moment';
import { addLocale } from 'primereact/api';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Paginator } from 'primereact/paginator';
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import React, { useEffect, useRef, useState } from "react";
import { LazyLoadImage } from 'react-lazy-load-image-component';
import 'react-lazy-load-image-component/src/effects/blur.css';
import { useNavigate } from "react-router-dom";
import { Slide } from 'react-slideshow-image';
import 'react-slideshow-image/dist/styles.css';
import 'react-toastify/dist/ReactToastify.css';
import view_apartment_type_ar from "../../functions/view_apartment_type";
import '../../Helper/links.js';
import { _endPoints, getapartments_dates_coming_resort } from "../../Helper/links.js";
import API from "../../Helper/server/API.js";
import img_apartment from '../../public/images/apartment.png';
import view_day_ar from '../../functions/view_day_ar';
import { Tooltip } from 'primereact/tooltip';

let today = new Date();
export let booking_apartments_dates = {};
function BookingApartmentTowStep({ onDataChange, bookingApartmentData }) {
    const toast = useRef(null);
    const items = Array.from({ length: 5 }, (v, i) => i);
    const [loading_render, set_loading_render] = useState(true);
    // addLocale('en', {
    //   firstDayOfWeek: 1,
    //   dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
    //   dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
    //   dayNamesMin: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
    //   monthNames: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']    ,
    //   monthNamesShort: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    //   today: 'Today',
    //   clear: 'Clear'
    // });
    addLocale('ar', {
        firstDayOfWeek: 6,
        dayNames: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        dayNamesMin: ['الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'],
        monthNames: ['January-01', 'February-02', 'March-03', 'April-04', 'May-05', 'June-06', 'July-07', 'August-08', 'September-09', 'October-10', 'November-11', 'December-12'],
        monthNamesShort: ['Jan-01', 'Feb-02', 'Mar-03', 'Apr-04', 'May-05', 'Jun-06', 'Jul-07', 'Aug-08', 'Sep-09', 'Oct-10', 'Nov-11', 'Dec-12'],
        today: 'اليوم',
        clear: 'تفريغ',
    });
    const Navigate = useNavigate();
    //_______________________________________________________
    const [apartments, setApartments] = useState([]);
    const [dates, setDates] = useState([]);
    //_______________________________________________________
    //                      Dates Apartments
    //_______________________________________________________
    function dates_close(dates_reservationes) {

        var dates_disabled = [];
        // eslint-disable-next-line array-callback-return
        dates_reservationes.map((date) => {
            var date_in = new Date(date.date_check_in);
            var date_out = new Date(date.date_check_out);
            while (Moment(date_in).format("yyyy-MM-DD") < Moment(date_out).format("yyyy-MM-DD")) {
                dates_disabled.push(new Date(Moment(date_in).format("yyyy-MM-DD")));
                date_in.setDate(date_in.getDate() + 1);
            }
        })
        return dates_disabled;
    }
    function dateTemplate(date, dates_reservationes) {
        var IsAvailable = true;
        for (var i = 0; i < dates_reservationes.length; i++) {
            if (
                Moment(date).format("yyyy-MM-DD") >= Moment(dates_reservationes[i].date_check_in).format("yyyy-MM-DD")
                &&
                Moment(date).format("yyyy-MM-DD") < Moment(dates_reservationes[i].date_check_out).format("yyyy-MM-DD")
            ) {
                IsAvailable = false;
                break;
            }
        }
        if (!IsAvailable) {
            return (
                <span className="strikethrough-red" >{date.day}</span>
            );
        }
        else {
            return (
                <span style={{ color: "black" }}>{date.day}</span>
            );
        }
    }
    const handelDates = (e, id_apartment) => {
        setDates(e.target.value);
        booking_apartments_dates[id_apartment] = e.target.value;
        onDataChange({
            id_apartment: id_apartment,
            dates: e.target.value
        })

    }
    const clear_days = async (e, id_apartment) => {
        setDates([])
        booking_apartments_dates[id_apartment] = [];
        onDataChange({
            id_apartment: id_apartment,
            dates: []
        })
    }

    //_______________________________________________________________________________________
    //                      Get Apartments
    const GetApartments = async () => {
        const response = await API.get(getapartments_dates_coming_resort)
        if (response?.success === 1) {
            if (Array.isArray(response.data))
                setApartments(response.data);
            // eslint-disable-next-line array-callback-return
            apartments.map((apartment) => {
                booking_apartments_dates[apartment.ID_apartment] = [];
            })
            bookingApartmentData.map((apartment) => {
                return booking_apartments_dates[apartment.id_apartment] = apartment.dates;
            })
            set_loading_render(false)
        }
        else if (response?.success === 0 || response?.errors == 1) {
            toast?.current?.show({
                style: {
                    fontFamily: "Cairo",
                    fontSize: "1.2rem"
                },
                life: 5000,
                severity: 'error', summary: 'خطــاء', detail: response?.msg
            });
        }
    }
    useEffect(() => {
        booking_apartments_dates = []
        GetApartments();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const [first, setFirst] = useState(0);
    const [rows, setRows] = useState(10);

    const onPageChange = (event) => {
        setFirst(event.first);
        setRows(event.rows);
    };
    const [selected_week, setSelectedWeek] = useState(Moment(new Date()).format());
    return (
        <div >
            <Toast ref={toast} position="top-center" style={{ margin: "0 1rem 0 0 !important", fontFamily: "Cairo" }} remove />
            <div dir="rtl" >
                <>
                    <style>
                        {`
                            .custom-table-calendar th,
                            .custom-table-calendar td {
                                vertical-align: middle !important;
                                transition: background-color 0.2s;
                            }
                            .custom-table-calendar td.cell-available {
                                background-color: #f8f9fa;
                                color: #6c757d;
                            }
                            .custom-table-calendar td.cell-available:hover {
                                background-color: #e2e8f0 !important;
                                cursor: pointer;
                                color: #10b981;
                            }
                            .custom-table-calendar td.cell-selected {
                                background-color: #d1fae5 !important;
                                cursor: pointer;
                                color: #059669;
                            }
                            .custom-table-calendar td.cell-booked {
                                background-color: #fee2e2 !important;
                                cursor: not-allowed;
                                color: #dc2626;
                                opacity: 0.8;
                            }
                            .custom-table-calendar td.cell-booked-2 {
                                background-color: #fcf8e3 !important;
                                cursor: not-allowed;
                                color: #dc2626;
                                opacity: 0.8;
                            }
                            `}
                    </style>

                    <div className="card p-3 shadow-sm mb-4">
                        <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="btn-group" dir="ltr">
                                <Button type="button" icon="pi pi-angle-left" className="p-button-outlined p-button-secondary" disabled={(Moment(selected_week).isAfter(Moment().add(1, 'year').startOf('week'))) ? true : false}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const el = document.getElementById('weekStartHack');
                                        const newDate = Moment(selected_week).add(1, 'w');
                                        if (Moment(selected_week).isAfter(Moment().add(1, 'year').startOf('week'))) {
                                            if (toast && toast.current) toast.current.show({ severity: 'warn', summary: 'إنتباه', detail: 'لا يمكن الحجز لأكثر من سنة مقدماً' });
                                            return;
                                        }
                                        el.value = newDate.format();
                                        setSelectedWeek(el.value)
                                        el.click();
                                    }} />
                                <Button type="button" icon="pi pi-angle-right" className="p-button-outlined p-button-secondary" disabled={Moment(selected_week).format('YYYY-MM-DD') === Moment().startOf('week').format('YYYY-MM-DD') ? true : false}
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const el = document.getElementById('weekStartHack');
                                        const newDate = Moment(selected_week).subtract(1, 'w');
                                        if (newDate.isBefore(Moment().startOf('week'))) {

                                            if (toast && toast.current) toast.current.show({ severity: 'warn', summary: 'إنتباه', detail: 'لا يمكن الحجز في الأيام الماضية' });
                                            return;
                                        }
                                        el.value = newDate.format();
                                        setSelectedWeek(el.value)
                                        el.click();
                                    }} />

                                <Button type="button" label="اليوم" className="p-button-outlined p-button-secondary"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        const el = document.getElementById('weekStartHack');
                                        el.value = Moment().startOf('week').format();
                                        setSelectedWeek(el.value)
                                        el.click();
                                    }} />
                            </div>

                            <input type="hidden" id="weekStartHack" defaultValue={Moment().startOf('week').format()} onClick={(e) => setDates([new Date(e.target.value)])} />

                            <center>
                                <h4 className="m-0 font-bold" style={{ fontFamily: "Cairo", color: "#334155" }} id="weekTitleHack">
                                    {(() => {
                                        const start = Moment(selected_week).startOf('week');
                                        return start.format('YYYY-MM-DD') + ' إلــي ' + Moment(start).add(6, 'days').format('YYYY-MM-DD');
                                    })()}
                                </h4>
                            </center>

                            <div>
                                {/* <span className="text-secondary" style={{ fontFamily: "Cairo", fontSize: "14px" }}><i className="fa fa-info-circle pr-2"></i>أنقر على خلايا الجدول لتحديد أو إلغاء حجز الشقق</span> */}
                            </div>
                        </div>

                        <div className="table-responsive">
                            <table className="table table-bordered text-center custom-table-calendar" style={{ minWidth: "1000px", fontFamily: "Cairo", borderCollapse: "collapse", height: "300px", overflowY: "auto" }}>
                                <thead className="table-light">
                                    <tr>
                                        <th style={{ width: "20%", fontSize: "16px", backgroundColor: "#f1f5f9" }}>الشقة</th>
                                        {(() => {
                                            const weekStart = Moment(selected_week).startOf('week');
                                            const headers = [];
                                            for (let i = 0; i < 7; i++) {
                                                const d = Moment(weekStart).add(i, 'days');
                                                headers.push(
                                                    <th key={d.format('YYYY-MM-DD')} style={{ width: "11%", backgroundColor: "#f1f5f9" }}>
                                                        <div className="font-bold text-dark" style={{ fontSize: "16px" }}>{d.format('MM-DD')}</div>
                                                        <div className="text-secondary" style={{ fontSize: "13px", fontWeight: "normal" }}>{view_day_ar(d)}</div>
                                                    </th>
                                                );
                                            }
                                            return headers;
                                        })()}
                                    </tr>
                                </thead>
                                {
                                    loading_render ?
                                        <tbody>

                                            {items.map((item, index) => (
                                                <tr key={item}>
                                                    <td className="text-right" classNamem="m-4"  >
                                                        <Skeleton width="100%" height="100%" />
                                                    </td>
                                                    <td className="text-right" style={{ backgroundColor: "#ffffff" }}>
                                                        <Skeleton width="100%" height="100%" />
                                                    </td>
                                                    <td className="text-right" style={{ backgroundColor: "#ffffff" }}>
                                                        <Skeleton width="100%" height="100%" />
                                                    </td>
                                                    <td className="text-right" style={{ backgroundColor: "#ffffff" }}>
                                                        <Skeleton width="100%" height="100%" />
                                                    </td>
                                                    <td className="text-right" style={{ backgroundColor: "#ffffff" }}>
                                                        <Skeleton width="100%" height="100%" />
                                                    </td>
                                                    <td className="text-right" style={{ backgroundColor: "#ffffff" }}>
                                                        <Skeleton width="100%" height="100%" />
                                                    </td>
                                                    <td className="text-right" style={{ backgroundColor: "#ffffff" }}>
                                                        <Skeleton width="100%" height="100%" />
                                                    </td>
                                                    <td className="text-right" style={{ backgroundColor: "#ffffff" }}>
                                                        <Skeleton width="100%" height="100%" />
                                                    </td>
                                                </tr>
                                            ))}

                                        </tbody>
                                        :
                                        <tbody>
                                            {apartments?.slice(first, first + rows).map((apt) => {
                                                const weekStart = Moment(selected_week).startOf('week');

                                                return (
                                                    <tr key={apt.ID_apartment}>
                                                        <td className="text-right" style={{ backgroundColor: "#ffffff" }}>
                                                            <div className="d-flex align-items-center">
                                                                <div className="mr-3 ml-2">
                                                                    {apt?.images?.length > 0 ? (
                                                                        <>
                                                                            {apt.images.map((img, k) => (
                                                                                <a
                                                                                    key={img.ID_apartments_file || `img-${k}`}
                                                                                    data-fancybox={`gallery-${apt.ID_apartment}`}
                                                                                    href={`${_endPoints.apartments.images}${img.path_file}`}
                                                                                    style={{ display: k === 0 ? 'inline' : 'none' }}
                                                                                >
                                                                                    {k === 0 && (
                                                                                        <LazyLoadImage
                                                                                            // Alt text should describe the image or its context
                                                                                            alt={`Apartment ${apt.number || ''} - Image ${k + 1}`}
                                                                                            effect="blur"
                                                                                            wrapperProps={{
                                                                                                style: { transitionDelay: "0.5s" },
                                                                                            }}
                                                                                            style={{ width: "90px", height: "70px", objectFit: "cover", borderRadius: "5px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", cursor: "pointer" }}
                                                                                            src={`${_endPoints.apartments.images}${img.path_file}`}

                                                                                            onError={e => {
                                                                                                e.target.src = img_apartment;
                                                                                                e.target.onerror = null; // Prevents infinite loops if fallback fails
                                                                                            }}
                                                                                        />

                                                                                    )}
                                                                                </a>
                                                                            ))}
                                                                        </>
                                                                    ) : (
                                                                        <a data-fancybox={`gallery-${apt.ID_apartment}`} href={_endPoints.apartments.images + "apartment.png"}>
                                                                            <img src={_endPoints.apartments.images + "apartment.png"} alt="apartment" style={{ width: "70px", height: "50px", objectFit: "cover", borderRadius: "5px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)", cursor: "pointer" }} />
                                                                        </a>
                                                                    )}
                                                                </div>
                                                                <div>
                                                                    <div className="font-bold text-primary" style={{ fontSize: "16px" }}>{view_apartment_type_ar(apt)} {apt.number}</div>
                                                                    <div className="text-secondary mt-1" style={{ fontSize: "13px" }}>
                                                                        <i className="fa fa-users pr-1"></i> {apt.number_people} أشخاص ·
                                                                        <span className="font-bold text-dark px-1">
                                                                            {apt.discount > 0 ? (
                                                                                <strong style={{ textDecoration: 'line-through', color: "red", fontSize: "13px", display: "inline" }}>
                                                                                    {apt.price + ' د.ل '}
                                                                                </strong>
                                                                            ) : null}
                                                                            <h6 style={{ display: "inline" }} className="pr-1">{apt.price - apt.discount + ' د.ل '}</h6>
                                                                        </span>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </td>
                                                        {(() => {
                                                            const cells = [];
                                                            for (let i = 0; i < 7; i++) {
                                                                const d = Moment(weekStart).add(i, 'days');
                                                                const dateStr = d.format('YYYY-MM-DD');
                                                                var reservation = null

                                                                var isBooked = apt.dates_reservationes.some(res => {
                                                                    if (dateStr >= Moment(res.date_check_in).format('YYYY-MM-DD') &&
                                                                        dateStr <= Moment(res.date_check_out).format('YYYY-MM-DD')) {
                                                                        reservation = res;
                                                                        return true;
                                                                    }
                                                                    return false;
                                                                });



                                                                const existingSelection = booking_apartments_dates[apt.ID_apartment] || [];
                                                                const targetTime = new Date(dateStr).getTime();
                                                                const isSelected = existingSelection.some(dt => new Date(dt).getTime() === targetTime);

                                                                let cellClass = "cell-available";
                                                                let icon = "fa-calendar-check-o";
                                                                let text = "متاح";


                                                                if (isBooked) {

                                                                    cellClass = reservation?.date_del_reservation ? "cell-booked" : "cell-booked-2";
                                                                    icon = reservation?.date_del_reservation ? "fa-ban" : "fa-clock-o";
                                                                    text = 'محجوز';
                                                                } else if (isSelected) {
                                                                    cellClass = "cell-selected";
                                                                    icon = "fa-check-circle";
                                                                    text = "محدد";
                                                                }
                                                                let isDisable = false
                                                                if (Moment(dateStr).format('YYYY-MM-DD') < Moment().format('YYYY-MM-DD')) {
                                                                    cellClass = "cell-not-available";
                                                                    icon = "";
                                                                    text = "-";
                                                                    isDisable = true
                                                                }

                                                                cells.push(
                                                                    <td key={dateStr} className={cellClass}
                                                                        onClick={() => {
                                                                            if (isBooked || isDisable) {
                                                                                toast?.current?.show({ severity: 'error', summary: 'خطاء', detail: 'هذا اليوم محجوز مسبقاً لهذه الشقة' });
                                                                                return;
                                                                            }

                                                                            let newList;
                                                                            if (isSelected) {
                                                                                newList = existingSelection.filter(dt => new Date(dt).getTime() !== targetTime);
                                                                            } else {
                                                                                newList = [...existingSelection, new Date(dateStr)];
                                                                            }
                                                                            booking_apartments_dates[apt.ID_apartment] = newList;

                                                                            // Trigger render
                                                                            const force = newList.length === 0 ? [new Date()] : newList;
                                                                            setDates([...force]);
                                                                            onDataChange({ id_apartment: apt.ID_apartment, dates: newList });
                                                                        }}>
                                                                        {
                                                                            isBooked ?
                                                                                <Tooltip target={`#apartment_${apt.ID_apartment}`} position="top" >
                                                                                    <div className="p-d-flex p-flex-column p-ai-center p-2">
                                                                                        <div className="p-text-center">
                                                                                            <b> رقم الحجز : </b>{reservation.ID_reservation} <br />
                                                                                            <b> اسم العميل : </b>{reservation.visitor_name} <br />
                                                                                            <b> رقم الهاتف : </b>{reservation.phone_number} <br />
                                                                                            <b>حالة الحجز :</b>
                                                                                            {reservation.date_del_reservation ? "مبدئى" : "مؤكد"}
                                                                                            <br />

                                                                                        </div>
                                                                                    </div>
                                                                                </Tooltip>
                                                                                : null

                                                                        }
                                                                        <div className="d-flex flex-column justify-content-center align-items-center" style={{ minHeight: "65px", padding: "10px 0" }} id={isBooked ? `apartment_${apt.ID_apartment}` : null}>
                                                                            <i className={`fa ${icon} mb-2`} style={{ fontSize: "1.2rem" }}></i>
                                                                            <strong style={{ fontSize: "14px", fontWeight: isSelected || isBooked || isDisable ? "bold" : "normal" }}>{text}</strong>
                                                                        </div>
                                                                    </td>
                                                                );
                                                            }
                                                            return cells;
                                                        })()}
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                }
                            </table>
                        </div>
                    </div>

                    <Paginator
                        first={first}
                        rows={rows}
                        totalRecords={apartments?.length}
                        rowsPerPageOptions={[10, 20, 30, 40]}
                        onPageChange={onPageChange}
                        style={{ fontSize: "14px" }}

                        nextPageLinkIcon="pi pi-chevron-left" lastPageLinkIcon="pi pi-angle-double-left"
                        prevPageLinkIcon="pi pi-chevron-right" firstPageLinkIcon="pi pi-angle-double-right"
                    />

                </>

            </div>
        </div>
    )
}

export default BookingApartmentTowStep


